import type { MaybeN } from "@agrigate/ts-utils/lib/types";
import type { BoxProps } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";

export default function ColorDot(p: {
    color?: MaybeN<string>;
    size?: string;
    boxProps?: BoxProps;
}) {
    const size = p.size ?? "8px";
    return (
        <Box
            height={size}
            width={size}
            backgroundColor={p.color || "transparent"}
            {...p.boxProps}
        />
    );
}
